var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376 248H155.3l106.3-106.3c3.125-3.125 3.125-8.188 0-11.31s-8.188-3.125-11.31 0l-120 120c-3.125 3.125-3.125 8.188 0 11.31l120 120C251.9 383.2 253.9 384 256 384s4.094-.7813 5.656-2.344c3.125-3.125 3.125-8.188 0-11.31L155.3 264H376C380.4 264 384 260.4 384 256S380.4 248 376 248zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 496c-132.3 0-240-107.7-240-240S123.7 16 256 16s240 107.7 240 240S388.3 496 256 496z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowLeft);
export default __webpack_public_path__ + "static/media/circle-arrow-left.03e663bb2bee64f694f15e5658ac9624.svg";
export { ForwardRef as ReactComponent };